import colors from '../config/colors.json'
import { findMap } from '../helpers/drafting'
import { getLang, mapLabel } from '../helpers/i18n'
import { matchTitleLabel } from './Dashboard/DraftDashboard'
import { matchTypeLabel } from '../helpers/matchTypeLabel'
import { useSocketEvent, useSocketState } from '../helpers/useSocket'
import { useState, useEffect } from 'react'
import 'chart.js/auto'

export default function LiveGame() {
	const [match] = useSocketState('Match')
	const [config, setConfig] = useState({})
	const [themeConfig, setThemeConfig] = useState(null)

	useSocketEvent('updateConfig', (newdata) => {
		console.log(`Received updateConfig`, newdata)
		setConfig(newdata)
	})

	useEffect(() => {
		const themeName = config.theme ?? config.cssTheme?.replace('.css', '.json')
		if (!themeName) return
		fetch(`/themes/${themeName}`)
			.then((r) => r.json())
			.then(setThemeConfig)
			.catch(() => setThemeConfig(null))
	}, [config.theme, config.cssTheme])

	//`?lang=fr`
	const lang = getLang()

	if (!match) return <div />

	const flipPlayers = match.flipPlayersIngame

	const leftPlayer = !flipPlayers ? match.leftPlayer : match.rightPlayer
	const rightPlayer = flipPlayers ? match.leftPlayer : match.rightPlayer

	const leftColor = colors[leftPlayer.color]
	const rightColor = colors[rightPlayer.color]
	const leftScore = leftPlayer.score
	const rightScore = rightPlayer.score

	document.body.style.overflow = 'hidden'

	const mapDetails = findMap(match.games.filter((v) => v.state === 'upcoming').reverse()[0]?.map)

	const theme = themeConfig?.liveGame ?? {}
	const showIngameScore = theme.showIngameScore ?? false
	const showIngameFlags = theme.showIngameFlags ?? false
	const showIngameScoreColor = theme.showIngameScoreColor ?? false
	const showMinimap = theme.showMinimap ?? false
	const showMatchType = theme.showMatchType ?? false
	const matchTypeFormat = theme.matchTypeFormat ?? 'short'
	const showMapName = theme.showMapName ?? false
	const showRoundInfo = theme.showRoundInfo ?? false
	const scoreDisplayType = theme.scoreDisplayType ?? 'number'
	const scoreBoxCount = Math.max(0, match.matchTypeLength ?? 0) / 2 + 1

	const cssFiles = themeConfig?.css ?? (config.cssTheme ? [config.cssTheme] : [])
	const cssVars = Object.fromEntries(Object.entries(themeConfig?.cssVariables ?? {}).map(([k, v]) => [k.startsWith('--') ? k : `--${k}`, v]))

	return (
		<div
			className="livegame"
			lang={lang}
			style={{
				'--left-player-color': leftColor?.mainColor,
				'--left-player-color-secondary': leftColor.secondaryColor,
				'--right-player-color': rightColor?.mainColor,
				'--right-player-color-secondary': rightColor?.secondaryColor,
				...cssVars,
			}}>
			{cssFiles.map((css) => (
				<link key={css} rel="stylesheet" type="text/css" href={`/themes/${css}`} />
			))}

			{showIngameScore && scoreDisplayType === 'number' && (
				<div className="ingameScoreWrapper">
					<div className="scoreContainer score-leftScore" data-score={leftScore}>
						<h1>{leftScore}</h1>
					</div>
					<div className="scoreContainer score-rightScore" data-score={rightScore}>
						<h1>{rightScore}</h1>
					</div>
				</div>
			)}

			{showIngameScore && scoreDisplayType === 'boxes' && (
				<div className="scoreBoxesWrapper">
					<div className="scoreBoxes scoreBoxes-left">
						{Array.from({ length: scoreBoxCount }, (_, i) => (
							<div key={i} className={`score-box score-box-${i}${i < leftScore ? ' score-box-filled' : ''}`} />
						))}
					</div>
					<div className="scoreBoxes scoreBoxes-right">
						{Array.from({ length: scoreBoxCount }, (_, i) => (
							<div key={i} className={`score-box score-box-${i}${i < rightScore ? ' score-box-filled' : ''}`} />
						))}
					</div>
				</div>
			)}

			{showIngameScoreColor && (
				<div className="ingameScoreColor">
					<div className={`scoreBannerWrapper-left`}>
						<div className="scoreBanner-img scoreBanner-left"> </div>
						<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${leftPlayer.color}-left`}></div>
					</div>
					<div className={`scoreBannerWrapper-right`}>
						<div className="scoreBanner-img scoreBanner-right"> </div>
						<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${rightPlayer.color}-right `}></div>
					</div>
				</div>
			)}

			{showMinimap && (
				<div className="minimapWrapper">
					{showMatchType && <div className="minimapMatchType">{matchTypeLabel(match, matchTypeFormat)}</div>}
					{showMapName && mapDetails && <div className="minimapMapName">{mapLabel(mapDetails, lang)}</div>}

					{showRoundInfo && <div className="minimapRoundInfo">{matchTitleLabel(match.matchTitle, lang)}</div>}
				</div>
			)}
		</div>
	)
}
